import { makeVar } from "@apollo/client";

export const showActionsheetVar = makeVar<boolean>(false);
